import React from 'react';
import { IconSizes } from '@newcore/icons';
import { Spinner } from '@newcore/ui/loading';
import { Text } from '@newcore/ui/typography';

/**
 * Loading state - shown while generating pairing code
 */
export const PairingLoadingState: React.FC = React.memo(
  (): React.ReactElement => (
    <div className='flex flex-col items-center justify-center py-8'>
      <Spinner size={IconSizes.LG} className='text-primary' />
      <Text as='p' className='mt-4 text-tertiary'>
        Generating pairing code...
      </Text>
    </div>
  )
);

PairingLoadingState.displayName = 'PairingLoadingState';
